import { ReactElement } from 'react';
import Backstory from './Backstory';
import Bitcoin from './Bitcoin';
import Bots from './Bots';
import WhichSubscription1 from './WhichSubscription1';
import WhichSubscription2 from './WhichSubscription2';
import Expactations from './Expactations';
import Terminology from './Terminology';
import ProfitExamples1 from './ProfitExamples1';
import ProfitExamples2 from './ProfitExamples2';
import ProfitExamples3 from './ProfitExamples3';
import ProfitExamples4 from './ProfitExamples4';
import ProfitExamples5 from './ProfitExamples5';
import ProfitExamples6 from './ProfitExamples6';

const Presentation = () => {
  return (
    <div
      style={{
        flex: 1,
        height: '100vh',
        width: '100vw',
        overflowY: 'scroll',
        scrollSnapType: 'y mandatory',
      }}
      className="no-scrollbar"
    >
      <Slide title="Backstory" content={<Backstory />} />
      <Slide
        title="Topics"
        items={[
          'Bitcoin',
          'What the project is not',
          'What the project is',
          'Bots and subscriptions',
          'Diversification',
          'Expectations',
          'Important terminology',
          'Examples',
          'Credit system',
          'Pricing',
          'Your job as alpha testers',
          'Next steps',
          'Demo',
          'Your account',
        ]}
      />
      <Slide title="Bitcoin" content={<Bitcoin />} />
      <Slide
        title="What the project is not"
        items={[
          'A scam project',
          'Get rich quick',
          'Perfect algorithm',
          'Money go up only',
          'Pot of gold at the end of the rainbow',
        ]}
      />
      <Slide
        title="What the project is"
        items={[
          'Tool that analyses historical data to predict future protitable transactions',
          'Risky, with risk protection',
          'Beat the market',
          'Long term powerhouse',
        ]}
      />
      <Slide
        title="Bots and subscriptions"
        items={[
          'One bot per coin',
          'Multiple subscriptions per bot',
          'Specific balance per subscription',
        ]}
        content={<Bots />}
      />
      <Slide
        title="Which subscriptions to add?"
        items={['Actually, it doesnt matter', 'Importance of diversifying']}
        content={<WhichSubscription1 />}
      />
      <Slide
        title="Which subscriptions to add?"
        content={<WhichSubscription2 />}
      />
      {/** Show charts */}
      <Slide title="Expectations" content={<Expactations />} />
      <Slide
        title="Important terminology"
        items={[
          'Stable balance',
          'Stable profit',
          'Asset balance',
          'Asset Profit',
          'SPC / CPC',
        ]}
        content={<Terminology />}
      />
      {/** Open SPC of:
       * Bitcoin
       * Ethereum
       * Solana
       * Vechain
       * Trump
       * Doge
       * Pepe
       * Cardano
       * Fartcoin
       * Uniswap
       * Litecoin
       */}
      <Slide title="Profit examples" content={<ProfitExamples1 />} />
      <Slide title="Profit examples" content={<ProfitExamples2 />} />
      <Slide title="Profit examples" content={<ProfitExamples3 />} />
      <Slide title="Profit examples" content={<ProfitExamples4 />} />
      <Slide title="Profit examples" content={<ProfitExamples5 />} />
      <Slide title="Profit examples" content={<ProfitExamples6 />} />
      <Slide
        title="Credits system"
        items={[
          'New bot = 2 credits',
          'Existing bot = 1 credit',
          '50 Credits total',
          'Open to change in the future',
        ]}
      />
      <Slide
        title="Pricing"
        items={[
          'Subscription based system',
          'Commission on each transaction',
          'Monthy commission based on algorithmic difference',
        ]}
      />
      <Slide title="Manually changing balances" />
      <Slide
        title="Your job as alpha testers"
        items={[
          'Report on bugs',
          'Ask questions',
          'Emails',
          'Improvements',
          'Legal Contract',
          'WhatsApp group',
        ]}
      />
      <Slide
        title="Next steps"
        items={[
          'Focus on profit improvements',
          'Take profit transactions',
          'Improved Stop loss',
          'Longing/Shorting',
          'Three-way bots',
          'Automatic fund distribution',
          'Monitization',
        ]}
      />
      <Slide title="Demo of the client portal" />
      <Slide title="Getting your account ready!" />
    </div>
  );
};

const Slide = ({
  title,
  items,
  content,
}: {
  title: string;
  items?: string[];
  content?: ReactElement;
}) => {
  const listOne = items?.length
    ? items.slice(0, Math.ceil(items.length / 2))
    : null;
  const listTwo = items?.length
    ? items.slice(Math.ceil(items.length / 2), items.length)
    : null;
  return (
    <div
      style={{
        display: 'flex',
        scrollSnapAlign: 'center',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <p
        style={{
          fontSize: 56,
          fontWeight: 'bold',
          marginBottom: 0,
          zIndex: 100,
        }}
      >
        {title}
      </p>
      {listOne?.length && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 64,
            marginTop: 32,
            fontSize: 28,
            marginLeft: '10%',
            marginRight: '10%',
          }}
        >
          <ul>
            {listOne?.map((item) => (
              <li key={item} style={{ marginTop: 6, marginBottom: 6 }}>
                {item}
              </li>
            ))}
          </ul>
          <ul>
            {listTwo?.map((item) => (
              <li key={item} style={{ marginTop: 6, marginBottom: 6 }}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}

      {content}
    </div>
  );
};

export default Presentation;
